import { useTranslation } from 'react-i18next'

import { LockSimpleIcon, PlusIcon } from '@phosphor-icons/react'
import { useTheme } from 'styled-components'

import { Text, Tooltip } from '@reveni-io/reveni-ui'

import { isBlockDisabled } from '../helpers'
import * as Styles from './styles'

const BlocksSidebarSection = ({ title, definitions, layout, locked, children, onAddBlock }) => {
  const { t } = useTranslation()
  const theme = useTheme()

  if (!definitions.length) return null

  return (
    <Styles.Container>
      <Text type="titleM">{title}</Text>
      <Styles.Body>
        {children}
        <Styles.BlocksList>
          {definitions.map(definition => (
            <Tooltip
              key={definition.id}
              backgroundColor={theme.colors.primary.default}
              title={
                locked ? (
                  <Text type="bodySRegular" color={theme.colors.primary.on}>
                    {t(definition.description)}
                  </Text>
                ) : (
                  ''
                )
              }
            >
              <Styles.BlockButtonWrapper>
                <Styles.BlockButton
                  fullWidth
                  disabled={locked || isBlockDisabled(definition, layout)}
                  onClick={() => onAddBlock(definition.id)}
                >
                  {locked ? <LockSimpleIcon size={20} /> : <PlusIcon size={20} />}
                  {t(definition.label)}
                </Styles.BlockButton>
              </Styles.BlockButtonWrapper>
            </Tooltip>
          ))}
        </Styles.BlocksList>
      </Styles.Body>
    </Styles.Container>
  )
}

export default BlocksSidebarSection
